/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HeatLoadByConsumptionRequestPost } from '../../models/heat-load-by-consumption-request-post';
import { HeatLoadByConsumptionResponse } from '../../models/heat-load-by-consumption-response';

export interface CalculationsControllerConsumption$Params {
      body: HeatLoadByConsumptionRequestPost
}

export function calculationsControllerConsumption(http: HttpClient, rootUrl: string, params: CalculationsControllerConsumption$Params, context?: HttpContext): Observable<StrictHttpResponse<HeatLoadByConsumptionResponse>> {
  const rb = new RequestBuilder(rootUrl, calculationsControllerConsumption.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<HeatLoadByConsumptionResponse>;
    })
  );
}

calculationsControllerConsumption.PATH = '/planning-projects/v1/calculations/heat-load/consumption';
